export default __webpack_public_path__ + "static/media/UG.dd6b19b4.ico";